module.exports = __webpack_public_path__ + "media/images/logos/google_meet-ff0f7361dc531781d5533f7d7d7d6b12.svg";